import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { getLeaderboard } from '../api';
import PageHeader from '../components/PageHeader';

export default function Players() {
  const { data } = useQuery({ queryKey: ['leaderboard'], queryFn: getLeaderboard });
  const standings = data?.standings ?? [];

  return (
    <>
      <PageHeader title="Players" subtitle="Tap a player to see their teams and calendar" />
      <div className="px-4 lg:px-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {standings.map((s) => (
          <Link
            key={s.name}
            to={`/players/${encodeURIComponent(s.name)}`}
            className="card p-4 hover:border-pitch-500/40 transition-colors"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="font-semibold">{s.name}</div>
              <div className="text-right">
                <div className="stat text-lg">{s.points} <span className="text-dim text-xs">now</span></div>
                <div className="stat text-pitch-400 text-xs">{s.projectedPoints.toFixed(1)} proj</div>
              </div>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {s.teams.map((t) => (
                <span key={t.code} className="pill bg-ink-800 text-chalk/90">
                  <span>{t.flag}</span>
                  <span>{t.code}</span>
                  <span className="text-pitch-400 ml-1">{t.points}</span>
                </span>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </>
  );
}
